var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProgress = function SvgProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.41263V7.70632L12 4.64807L9 1.58981V3.8835C5.685 3.8835 3 6.62064 3 10C3 11.2004 3.345 12.3166 3.93 13.257L5.025 12.1408C4.6875 11.5062 4.5 10.7722 4.5 10C4.5 7.4693 6.5175 5.41263 9 5.41263ZM14.07 6.74297L12.975 7.85923C13.305 8.50146 13.5 9.2278 13.5 10C13.5 12.5307 11.4825 14.5874 9 14.5874V12.2937L6 15.3519L9 18.4102V16.1165C12.315 16.1165 15 13.3794 15 10C15 8.79964 14.655 7.68338 14.07 6.74297Z",
    fill: "currentColor"
  })));
};

export default SvgProgress;